
/**
 * @deprecated A gestão de papéis de projeto foi unificada em
 * /settings?tab=access (Acessos & Permissões → contexto Projeto).
 */
export default function ProjectRolesRedirect() {
    return null;
}

